import React from 'react'
import NumberFormat from 'react-number-format'

export default function NumberFormatCustom(props) {
	const { inputRef, onChange, format, ...other } = props

	return (
		<NumberFormat
			{...other}
			// format={format}
			allowNegative={false}
			getInputRef={inputRef}
			onValueChange={(values) => {
				onChange({
					target: {
						value: values.value,
					},
				})
			}}
			onPaste={(e) => {
				const pastedText = e.clipboardData.getData('Text')
				e.preventDefault()
				if (typeof pastedText === 'string') {
					let modifiedText = pastedText.replace(/[^0-9]+/g, '').trim()
					const difference = modifiedText.length - 10
					if (difference > 0) {
						modifiedText = modifiedText.slice(difference)
					}

					onChange({ target: { value: modifiedText } })
				}
			}}
		/>
	)
}
